/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_Existing_TitleInputs */

const en_plan_choose_existing_title = /** @type {(inputs: Plan_Choose_Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a codebase`)
};

const id_plan_choose_existing_title = /** @type {(inputs: Plan_Choose_Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari codebase`)
};

/**
* | output |
* | --- |
* | "From a codebase" |
*
* @param {Plan_Choose_Existing_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_existing_title = /** @type {((inputs?: Plan_Choose_Existing_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_Existing_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_existing_title(inputs)
	return en_plan_choose_existing_title(inputs)
});